import React, { useState,useContext,useEffect } from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ShiftProps } from "../interfacesProps/ShiftProps";
import { ShiftService } from "../api/ShiftService";
import { ShiftRelatedConstants, ShiftRelatedStylingConstants } from "../util/ShiftConstants";
import { Colors, FontSize, FontWeight, Spacing } from "../theme/Theme";
import moment from "moment-timezone";
import { capitalize, ButtonBase, Checkbox } from "@material-ui/core";
import {
  defaultKmAllowanceIcon,
  defaultAccomodationAllowanceIcon,
} from "../util/Icons";
import { RBShiftLayoutButton } from "./RBShiftLayoutButton";
import { formatWorkerType } from "../util/FormattingService";
import { IndustryModeEnum, roleNameEnum } from "../util/Common";
import { UIRelatedConstants } from "../theme/Theme";
import { RBContext } from './RBContext';
import { AuthService } from "../api/AuthService";
import { ObjectLiteral } from "../interfacesProps/ObjectLiteralProps";
import { defaultAllowOffersIcon } from '../components/RBShiftRelatedIcons';
import { RoutePathConstant} from "../util/Common";
import { useHistory } from "react-router-dom";
import { findUserShiftRequest } from "../util/ShiftToRequest";
const useStyles = makeStyles({
  Card: {
    "&:hover": {
      backgroundColor: "#E5E5E5",
      cursor: "pointer",
    },
  },
  CardContent: {
    paddingTop: 8,
    "&:last-child": {
      paddingBottom: 8,
    },
  },
  button: {
      borderRadius: UIRelatedConstants.ButtonBorderRadius,
      borderWidth: 1,
      backgroundColor: "#FFF",
      "&:hover": {
        backgroundColor: "#CDCDCD",
      },
    },
});
interface RBShiftLayoutCardForApplicantProps {
  shift: ShiftProps;
  rolename: string;
  onClick: (shiftId: string) => void;
  account:ObjectLiteral
  selected:any
  toggleShiftSelection: (index: any, shiftId: any) => void; // Add this prop
  userId: string;
}

const  renderRequestedWage = (requestedWage:any, shift:any) => {

  const allowOffers = shift.allowOffers;

  if (allowOffers) {
    if (shift.pharmacy?.networkPaid) {
        shift.requestedWage = requestedWage;
        const workerFee = requestedWage/100 ;
      
      return (
        <div style={{ fontWeight: "bold", textAlign: "right" }}>
            Requested Rate: {'$' + workerFee.toFixed(2)}
          </div>
      )
    }
    else {
      return (
        <div style={{ fontWeight: "bold", textAlign: "right" }}>
          Requested Rate: {'$' + (requestedWage / 100).toFixed(2)}
        </div>
      )
    }
  } else{
    return null
  }
};
const getAllowanceCostWithTax = (shift: any,account:any) => {
  let pharmacy = account.pharmacies.filter((pharmacy:any) => pharmacy.id === account.owner.defaultPharmacyId)[0];
  const taxRate = (pharmacy.salesTaxRate ??
    0) / 100;
  const allowanceCost =
    ((Math.round((shift.distance * 2) / 1000) * shift.kmAllowance) /
      100 +
      shift.accomodationAllowance / 100) *
    (1 + taxRate);
  return allowanceCost;
};

const renderAllowance = (shift: ObjectLiteral,account:any) => {
  const allowanceCost = getAllowanceCostWithTax(shift,account);
 
  return (
    <div>
      Allowance Cost: { "$" + allowanceCost.toFixed(2)}
    </div>
  )
   
};

const renderContentForPharmacy = (
  shift: ShiftProps,
  setCardActionAreaClickable: (actionAreaClickable: boolean) => void,
  selected:any,
  rolename: string,
  account:any,
  industryMode:string,
  secondaryColor:string,
  toggleShiftSelection: (index: any, shiftId: any) => void,
  history:any,
  classes:any,
  primaryColor:any,
  userId:string
) => {
   console.log('shift object in RBShiftLayoutCardForApplicant =>',shift)
  const startTime = moment(shift.officialStartTime).tz(shift.shiftTimeZone);
  const endTime = moment(shift.officialEndTime).tz(shift.shiftTimeZone);
  const hoursDisplay = ShiftService.getShiftLengthDisplayForOriginal(shift);
  //const wage = ShiftService.getWage(shift,account);
  const wage = (industryMode === IndustryModeEnum.Dentistry || industryMode === IndustryModeEnum.Labour) ?(ShiftService.getWage(shift,account)).toFixed(2) : (shift.actualCommission !== undefined && shift.actualCommission !== null ? shift.wage  : (ShiftService.getWage(shift,account)).toFixed(2));


  const workerType = shift.pharmacistType;
  //example: Wed, Nov 6th 2019
  const dateDisplay = startTime.format("ddd, MMM Do YYYY");
  const pharmacyName = shift.pharmacy.name ?? "N/A";


  const { isAssigned } = shift.flags;
  const { allowOffers } = shift;
  const requestedWage = (shift.shiftToRequests && shift.shiftToRequests.length > 0) ? shift.shiftToRequests[0].requestedWage : null;
  console.log("requestedWage",requestedWage)
   console.log("shifts object from renderContentForPharmacy =>",shift)
   // find the request corresponding to this user (pharmacist) using util
 const userRequest = findUserShiftRequest(shift, userId);
 console.log("userRequest",userRequest)

 // show badge only if any of these flags are truthy on the user's request
 const isRequested =
  !!userRequest &&
  (userRequest.isWageRequested === true ||
   userRequest.isStartTimeRequested === true ||
   userRequest.isEndTimeRequested === true);

   // color for outlines: blue when requested, orange otherwise
 const outlineColor = isRequested ?  "#F57C00":"#2B3270";
     

  return ( <>
    <div>
      {shift.shiftToRequests && shift.shiftToRequests.length > 0 && 
      // <div style={{ display: "flex", flexDirection: "row", flex: 1, marginLeft:-10 }}>
      <div
          // style={{ alignItems: "flex-end" }}
          style={{
            display: "grid",
            gridTemplateColumns: "48px 1fr 48px",
            alignItems: "center",
            marginBottom: 8,
          }}
          onMouseEnter={() => {
            setCardActionAreaClickable(false);
          }}
          onMouseLeave={() => {
            setCardActionAreaClickable(true);
          }}
        >
          <div 
          // style={{display:"flex" ,alignItems: "center"}}
          style={{ justifySelf: "start", paddingLeft: 4 }}
          >
            {/* <span>Applied with Request</span> */}
         
         <Checkbox
          checked={selected}
          style={{
            color: selected ? secondaryColor : Colors.darkGrey,
          }}
          onChange={(event) => {
            event.stopPropagation(); // Stop the event from propagating to the card's onClick
            toggleShiftSelection(shift.index, shift.id); // Call the parent's toggleShiftSelection
          }}
        />
         </div>

        {isRequested && (
          <div style={{ justifySelf: "center", textAlign: "center" }}>
            <span style={{ fontWeight: "bold", fontSize: 13 }}>
              Applied with Request
            </span>
          </div>
        )}
           <div style={{ justifySelf: "end", paddingRight: 4 }} />
        </div>
        // </div>
        }
        
   
      <div style={{ display: "flex", flexDirection: "row", flex: 1 }}>
        <div style={{ flex: 3 }}>
          <div style={{ fontWeight: "bold" }}>
            {capitalize(startTime.fromNow())}
          </div>
          <div>{dateDisplay}</div>
          <div>
            {startTime.format("hh:mm a")} - {endTime.format("hh:mm a")}
          </div>
          {requestedWage && renderAllowance(shift,account)}
        </div>
        <div
          style={{
            flex: 2,
            display: "flex",
        flexDirection: "column",
            alignItems: "flex-end",
            justifyContent: "space-between",
          }}
        >

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "center",
              // marginTop: spacing.small,
            }}
          >
            <div style={{ marginRight: 4,fontWeight: "bold" }}>${(wage / 100).toFixed(2)}/hr</div>
            { (allowOffers && !isAssigned) && 
              <div style={{paddingTop:2}}>
                 {defaultAllowOffersIcon(secondaryColor)}
              </div>
            }
          </div>


          <div style={{ fontWeight: "bold", textAlign: "right" }}>
            {formatWorkerType(workerType)}
          </div>
          <div style={{ fontWeight: "bold", textAlign: "right" }}>
            {hoursDisplay}
          </div>
{/* {requestedWage && renderRequestedWage(requestedWage,shift)} */}

                  {requestedWage && 

          <div>
          <Button
                    className={classes.button}
                    variant="outlined"
                    style={{
                       borderColor: outlineColor,
                      border: `2px solid ${outlineColor}`,
                      color: outlineColor,
                      textTransform: "none",
                    }}
                     onClick={(e) => {
                      e.stopPropagation()
                      history.push(`${RoutePathConstant.ViewRequestApplicant + shift.id}/${userId}`);
                    }}
                  >
                    View Request
                  </Button>

        
      </div>
}

            
        </div>
      </div>
    </div>

    </>
  );
};



const RenderShiftLayoutForPharmacy = (
  shift: ShiftProps,
  onClick: (shiftId: string) => void,
  selected:any,
  rolename: string,
  account:any,
  toggleShiftSelection: (index: any, shiftId: any) => void,
  history:any,classes:any,
  userId:string
) => {
  const { industryMode,primaryColor,secondaryColor } = useContext(RBContext);

  const [CardActionAreaClickable, SetCardActionAreaClickable] = useState(true);

  const [stateColor,setStateColor] = useState<any>( ShiftRelatedStylingConstants.Colors[
    ShiftService.getStatusForShiftAsPharmacy(shift,rolename,industryMode)
  ])
  const state = ShiftService.getStatusForShiftAsPharmacy(shift,rolename,industryMode);

  useEffect(() => {
    const stateGlobalColor = ShiftRelatedStylingConstants.Colors[
      ShiftService.getStatusForShiftAsPharmacy(shift,rolename,industryMode)
    ]
    if(stateGlobalColor === '#2B3270')
    {
      setStateColor(primaryColor)
    }
    else if(stateGlobalColor === '#6EC9CD'){
      setStateColor(secondaryColor)
    }
    console.log('stateColor',stateColor)
  }, []);
  
  return (
    <Card
      variant="outlined"
      className={classes.Card}
      style={{
        borderRadius: UIRelatedConstants.CardBorderRadius,
        borderWidth: 3,
        borderColor: stateColor,
        backgroundColor: shift.shiftToRequests && shift.shiftToRequests.length === 0 ? Colors.defaultGrey : "white"
      }}
    >
      <div
        onClick={() => {
          if (CardActionAreaClickable) {
            onClick(shift.id);
          } else {
            console.log("CardActionAreaClickable is false");
          }
        }}
      >
        <CardContent className={classes.CardContent}>
          {renderContentForPharmacy(
            shift,
            SetCardActionAreaClickable,
            selected,
            rolename,
            account,
            industryMode,
            secondaryColor, 
            toggleShiftSelection,
            history,
            classes,
            primaryColor,
            userId,
          )}
        </CardContent>
      </div>
    </Card>
  );
};

export const RBShiftLayoutCardForApplicant: React.FC<RBShiftLayoutCardForApplicantProps> = ({
  ...props
}) => {
  const {userId} = props;
  const history = useHistory();
const classes = useStyles();
     

  const { shift, onClick, rolename ,account, selected, toggleShiftSelection} = props;
  if (rolename === roleNameEnum.owner) {
    return (
      <div
        style={{
          paddingLeft: Spacing.large,
          paddingRight: Spacing.large,
          paddingBottom: Spacing.medium,
        }}
      >
        {RenderShiftLayoutForPharmacy(shift, onClick,selected, rolename,account,toggleShiftSelection,history,classes,userId)}
      </div>
    );
  }
  return <></>;
};
